import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { user, customer } from "localStorage";

const AuthVerify = (props) => {
  let location = useLocation();

  useEffect(() => {
    // With cookie-based authentication, we check for stored user/customer data
    // The actual token validation is handled by the server via httpOnly cookies
    const userData = user();
    const customerData = customer();
    
    // If no user or customer data exists, user is not authenticated
    if (!userData && !customerData) {
      props.logOut();
    }
    
    // Note: Token expiration is now handled automatically by the API interceptor
    // which will refresh tokens or redirect to login as needed
  }, [location, props]);

  return null; // This component doesn't render anything
};

export default AuthVerify;